import {createLegoTheme} from "lego-gui-lib";

export const color = {} as any;
color.magenta = "rgb(226, 0, 116)";
color.black = "#000";

export const verticalIconTab = {} as any;
verticalIconTab.width = "56px";

export const createTheme = (bgColor?: string) => createLegoTheme({
    typography: {},
    palette: {
        background: {
            header: color.black,
            default: bgColor
        },
        primary: {
            main: color.magenta
        },
        secondary: {
            main: color.magenta
        },
        type: "light"
    }
});
